var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHouse = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m12.426 6.177 4.626 4.729c.224.231.349.541.348.863v5.029a1.2 1.2 0 0 1-1.134 1.2H14.4v-4.2a.6.6 0 0 0-.6-.6h-3.6a.6.6 0 0 0-.6.6v4.2H7.734a1.2 1.2 0 0 1-1.134-1.2V11.77a1.2 1.2 0 0 1 .348-.858l4.626-4.735a.6.6 0 0 1 .852 0m-1.626 8.22h2.4v3.6h-2.4z",
  clipRule: "evenodd"
})));
export default SvgHouse;